import React from 'react';
import { FEATURES } from '../data/content';
import Icon from './Icon';
import './FeaturesSection.css';

export default function FeaturesSection() {
  return (
    <section className="section feat-section">
      <div className="sec-in">
        <div className="eyebrow">Why choose us</div>
        <div className="sec-title">Peace of mind for every homeowner</div>
        <div className="sec-sub">
          Whether your AC quits in August or your water heater fails at midnight,
          one call gets your home back to normal — fast.
        </div>

        <div className="feat-grid">
          {FEATURES.map((f) => (
            <div key={f.title} className="feat-card">
              <div className="feat-ico" style={{ background: f.bg }}>
                <Icon name={f.icon} size={22} strokeWidth={1.75} />
              </div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
